import * as React from 'react';
import { useSelector } from 'react-redux';
import { ManagementCompany } from '../../components/ManagementCompany';
import { RefWrapper } from '../../components/packages/RefWrapper';
import { selectManagementCompany } from '../../selectors/managementCompany';
import { TRefWrapper } from '../Scrolling';

interface IManagementCompanyContainerProps {
  refWrapper: TRefWrapper;
}

export const ManagementCompanyContainer: React.FC<IManagementCompanyContainerProps> = ({ refWrapper }) => {
  const data = useSelector(selectManagementCompany);

  if (!data) {
    return null;
  }

  return refWrapper(
    <RefWrapper>
      <ManagementCompany data={data} />
    </RefWrapper>,
  );
};

ManagementCompanyContainer.displayName = 'ManagementCompanyContainer';
